import {
    FETCH_PREVIEW_WEATHER_DATA,
    FETCH_CURRENT_SITE_WEATHER_DATA
} from '../actions/actionTypes';

const initialState = {
    weatherData:            [],
    currentSiteWeatherData: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PREVIEW_WEATHER_DATA:
            return {
                ...state,
                weatherData: [...action.payload]
            };
        case FETCH_CURRENT_SITE_WEATHER_DATA:
            return {
                ...state,
                currentSiteWeatherData: [...action.payload]
            };
        default:
            return state;
    }
};
